export const ThumbnailSizes = {
  ICON: 'icon',
  THUMB: 'thumb',
  PREVIEW: 'preview',
  MEDIUM: 'medium',
} as const;

export type ThumbnailSize =
  (typeof ThumbnailSizes)[keyof typeof ThumbnailSizes];
